// GENERATED FILE - DO NOT MODIFY

export enum FoodPromotionStatusDto {
    Ongoing = "Ongoing",
    Upcoming = "Upcoming",
    Expired = "Expired",
    Unknown = "Unknown",
}